import { render, staticRenderFns } from "./SectorsWidget.vue?vue&type=template&id=48924588&"
import script from "./SectorsWidget.vue?vue&type=script&lang=js&"
export * from "./SectorsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports